<template>
    <Transition name="squeeze" @enter="addGlow">
        <div v-if="show">
            <el-divider />

            <el-row class="centred">
                <el-col :span="3">
                    <div class="label">
                        <p>
                            {{ $t('translationConfig.readingOprions') }}
                        </p>
                    </div>
                </el-col>

                <el-col :span="3">
                    <el-select v-model="readingOption"
                               @change="configChanged"
                               :disabled="disabled"
                               default-first-option>

                        <el-option v-for="(item) in readOptions"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id" />
                    </el-select>
                </el-col>
            </el-row>
        </div>
    </Transition>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { powerPointConfigurationService } from './powerPointConfigurationService'

    import { TranslationConfiguration } from '@/models/TranslationConfiguration'
    import { DocumentType } from '@/models/DocumentType'
    import { PptxReadOption } from '@/models/PptxReadOption';

    export default defineComponent({
        props: {
            modelValue: Object as PropType<TranslationConfiguration>,
            documentType: {
                type: Number as PropType<DocumentType>,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                readOptions: powerPointConfigurationService.getReadOptions(),
            }
        },
        computed: {
            configuration(): TranslationConfiguration {
                return this.modelValue as TranslationConfiguration;
            },
            readingOption: {
                get(): PptxReadOption {
                    return this.configuration?.pptxReadingOption == null ?
                        PptxReadOption.SlidesOnly : this.configuration.pptxReadingOption
                },
                set(value: PptxReadOption) {
                    this.configuration.pptxReadingOption = value
                }
            },
            show(): boolean {
                return this.documentType == DocumentType.Pptx
            },
        },
        methods: {
            addGlow(el: any) {
                // Trigger glow animation
                el.classList.add('glow');
                setTimeout(() => el.classList.remove('glow'), 1000); // Remove glow after 1 second
            },
            configChanged() {
                this.$emit("configChanged");
            },
        }

    })

</script>

<style lang="scss" scoped>
    .centred {
        align-items: center;
    }

    .label {
        font-size: 13px;
    }

    .squeeze-enter-active,
    .squeeze-leave-active {
        transition: all 0.5s ease;
        max-height: 230px;
    }

    .squeeze-enter-from,
    .squeeze-leave-to {
        opacity: 0;
        max-height: 0px;
    }

    .glow {
        animation: glow-effect 0.8s ease-out;
    }

    @keyframes glow-effect {
        0% {
            box-shadow: 0 0 10px rgba(121, 187, 255, 0.4);
        }

        50% {
            box-shadow: 0 0 15px rgba(121, 187, 255, 1);
        }

        100% {
            box-shadow: 0 0 5px rgba(121, 187, 255, 0.4);
        }
    }
</style>
